  <!-- 家庭作业 -->
  <template>
      <div class="fuzzy-matching-box">
          <!-- 家庭作业 -->
        <div class="fuzzy-matching-top">
          <el-row class="top-first-line the-second-line">
            <el-col :span="5">
              <el-form-item label="标题:">
                <el-input v-model="Dform.rfid" placeholder=''></el-input>
              </el-form-item>
            </el-col >
            <el-col :span="5">
              <el-form-item label="时间:">
                <el-input v-model="Dform.gradeName" placeholder=''></el-input>
              </el-form-item>
            </el-col >
            <el-col :span="5">
              <el-form-item label="To:">
                <el-input v-model="Dform.className" placeholder=''></el-input>
              </el-form-item>
            </el-col >
          
              <el-col :span="5">
              </el-col >
          </el-row>
          <el-row class="top-first-line the-second-line">
            <el-col :span="5">
              <el-form-item label="学校:">
                <el-input v-model="Dform.schoolName" placeholder=''></el-input>
              </el-form-item>
            </el-col >
            <el-col :span="5">
              <el-form-item label="年级:">
                <el-input v-model="Dform.name" placeholder=''></el-input>
              </el-form-item>
            </el-col >
            <el-col :span="5">
              <el-form-item label="班级:">
                <el-input v-model="Dform.title" placeholder=''></el-input>
              </el-form-item>
            </el-col >
           
              <el-col :span="5">
              </el-col >
            <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
          </el-row>
        </div>
        <div class="fuzzy-matching-content">
            <el-button type="text" class="textButton" @click="AddClick">发布作业</el-button>
        </div>
       
        <div class="fuzzy-matching-bottom">
          <el-row class="list">
            <el-table
              stripe
              :border="true"
              v-loading="loading"
              :header-cell-style="{background:'#EDF6FF',color:'#000',}"
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
                  <el-table-column
                    prop="title"
                    label="标题"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="studentNo"
                    label='作业范围'
                    >
                    </el-table-column>
                    <el-table-column
                    prop="created"
                      label="发布时间"
                      >
                    </el-table-column>
                    <el-table-column
                    prop="finished"
                    label="完成时间"
                       >
                    </el-table-column>
                    <el-table-column
                    prop="authorName"
                    label="发布人"
                    >
                    </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180"
                  >
                <template #default="scope">
                  <div v-if="userId == scope.row.authorId">
                    <el-button type="text" size="small" class="query-button"  @click="reviseClick(scope.row)">修改</el-button>
                    <el-button type="text" size="small" class="shanchuBtn" @click="deleteClick(scope.row)">删除</el-button>
                  </div>
              </template>
              </el-table-column>
              
            </el-table>

            <div class="block-fenye" >
              <el-pagination
                  :small="small"
                  :disabled="disabled"
                  :background="background"
                  layout="prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
            </div>
          </el-row>

        </div>
      </div>
      <Add v-if="addShow" :reviseItem="reviseItem" :objLookTeacher="objLookTeacher" @backClick="backClick"></Add>
    </template>
    <script>
    import { homeworkList,homeworkDelete } from '@/assets/api/schoollog';
    import { findTeacherInfo } from '@/assets/api/renyuan';
    import Add from './fabu/add.vue'
  //   import { ElMessage } from 'element-plus'
    export default {
      components: {
        Add
      },
      data() {
          return {
            // loading:true,
            Dform:{
              className:"",
              gradeName:"",
              schoolName:"",
              rfid:"",
              studentName:"",
              studentNo:"",
            },
            tableData:[],
            total:"",
            pageInfo:{
              pageSize:"10",
              page:"1",
            },
            theuserValue: 'ff245e1e-8347-4bd4-a714-88d6f0641c96',
            theuserList: [],
            tempFile: "", //文件
            titleValue: '',
            addShow: false ,
            detailsObj: {},
            Deviceidobj :{},
            reviseItem: {},
            objLookTeacher: {},
           userId: JSON.parse(localStorage.getItem('user')).id


          };
      },
      created() {
      //   this.schoolOrUserManagementListSearch()
      this.LookTeacher()
      },
      mounted() {
    
      },
      methods: {
        backClick () {
          this.addShow = false
          this.homeworkList()
        },
        LookTeacher() {
          const params = {
            userId: JSON.parse(localStorage.getItem('user')).id,
          }
          findTeacherInfo(params).then((res) => {
            this.objLookTeacher = res.data.data
            console.log(res.data.data, '查看当前登录人权限');
            this.homeworkList()
          }).catch((err) => {
            console.log(err);
          })
        },
        homeworkList () {
          let params = {
            className: this.Dform.title,
            endDate: this.Dform.gradeName,
            gradeName: this.Dform.name,
            page:this.pageInfo.page,
            pageSize:this.pageInfo.pageSize,
            schoolName: this.Dform.schoolName,
            title: this.Dform.rfid,
            userId: JSON.parse(localStorage.getItem('user')).id,
          }
          homeworkList(params).then((res)=> {
            console.log(res,'列表');
            this.tableData = res.data.data.list
            this.total = res.data.data.total
          }).catch((err)=> {
            console.log(err,444);
          })
        },

        // 新增按钮
        AddClick () {
          this.titleValue = '发布作业'
          this.addShow = true
        },
        reviseClick (item) { 
          this.addShow = true
          this.reviseItem = item
        },
    
        //删除
        deleteClick(item){
          console.log(item,'删除');
          const params ={
            id:item.id
          }
          homeworkDelete(params).then((res) => {
            console.log(res,222);
            this.homeworkList()
            this.$message({
                message: '删除成功！',
                type: 'success'
            });
          }).catch((err) => {
            console.log(err,111);
          })
        },

      //   schoolOrUserManagementListSearch(){
      //     const params = {
      //       className:this.Dform.className,
      //       rfid:this.Dform.rfid,
      //       gradeName:this.Dform.gradeName,
      //       schoolName:this.Dform.schoolName,
      //       studentName:this.Dform.studentName,
      //       studentNo:this.Dform.studentNo,
      //       page:this.pageInfo.page,
      //       pageSize:this.pageInfo.pageSize,
      //       userId:JSON.parse(localStorage.getItem('user')).id,
      //     }
      //     schoolOrUserManagementList(params).then((res)=> {
      //         // console.log( res.data.data.list,'学生管理成功');
      //         this.tableData = res.data.data.list
      //         this.total = res.data.data.total
      //         this.loading = false

      //     }).catch((err)=> {
      //       console.log(err,'学生管理失败');

      //     })
      //   },
        entrylogClick(){
          // this.schoolOrUserManagementListSearch()
        },
        handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageInfo.page = val
      //   this.schoolOrUserManagementListSearch()
      },
      },
    };
    </script>
    
    <style scoped lang="scss">
    .fuzzy-matching-box {
      padding-top: 20px;
      // overflow: hidden;
      overflow: auto;
      width: 100%;
      height:  96%;
      background-color: #fff;
      border-radius: 8px;
      .textButton {
        margin: 2px;
        padding: 0px;
        font-size: 15px;
        font-weight: 700;
      }
      .title-top {
          padding: 20px 20px;
      }
      .fuzzy-matching-top {
          height: 130px ;
          background-color: #fff;
          border-radius: 8px;
      .top-first-line {
        /deep/ {
          .el-form-item--small .el-form-item__label {
            // background-color: red;
            font-size: 16px;
          }
          .el-select--small {
              width: 100%
          }
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;          
          }
          .el-input {
            width: 100%;
            height: 35px;
          }
        }
      }
      .the-second-line {
        margin-top: 15px;
        position: relative;
        .query-button {
          position: absolute;
          right: 300px;
          padding: 16px 24px;
          // top: 50%;
          // transform: translate(0,-50%);
        }
      
      }
      /deep/ {
        .el-range-editor--small.el-input__wrapper {
            height: 35px;
            line-height: 35px;  
        }
      }

    }
    .fuzzy-matching-content{
      height: 20px;
      line-height: 20px;
      margin-bottom: 10px;
      font-size: 18px !important;
      /deep/{
          .el-button{
              margin-left:50px;
              font-size: 16px;
              
          }
      }
    }
    .fuzzy-matching-bottom {
          // position: absolute;
          padding: 20px;
          .query-button {
            padding: 2px;
            font-size: 15px;
            font-weight: 700;
         }
          .shanchuBtn{
            margin: 2px;
            padding: 2px;
            font-size: 15px;
            font-weight: 700;
            color: red;
          }
          /deep/{
            .el-table th.el-table__cell>.cell {
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 16px;
              font-weight: 700;
          }
          .el-table td.el-table__cell div{
            text-align: center;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: black;
          }
          .el-table:not(.el-table--border) .el-table__cell{
            border: 0;
          }
          .el-button--small {
            font-size: 16px;
              margin: 0;
              padding: 10px;
          }
          .fuzzy-matching-box .fuzzy-matching-bottom .el-button--small {
            font-size: 16px !important;
          }
    } 
        .block-fenye{
          margin-left: 1000px;
          margin-top: 15px;
    }
  }
    .upload-box {
    margin-top: 15px;
    .upload-lef {
        margin-left: 20px;
        font-size: 14px;
        .upload-title {}
    }
    .el-table tr {
        font-size: 20px;
    }
    
    /deep/ {
      .el-table--enable-row-transition .el-table__body td.el-table__cell{
        font-size: 40px;
      }
  
            .el-select .el-input__inner {
                height: 35px;
            }
            .el-form-item--small .el-form-item__label{
                margin-left: 20px;
                line-height: 35px;
            }
            
            .el-upload-list {
                // dis
                font-size: 80px;
            }
            
            
        }
    }
  }
    </style>
